let $ = window.jQuery;
if (typeof $ === 'undefined') {
  $ = require('jquery');
}

module.exports = {
  init() {
    $(document).ready(() => {
      $(".faq-collapse").collapse({
        accordion: true,
      });
      
      if(window.location.hash.length > 0) {
        $(window.location.hash).find("a").trigger("open");
        $('html,body').animate({ scrollTop: $(window.location.hash).offset().top});
      }

      $(".faq-collapse").bind("opened", function(e, section) {
        if(history.pushState) {
          history.pushState(null, null, '#'+section.$summary.attr('id'));
        } else {
          window.location.hash = section.$summary.attr('id');
          e.preventDefault();
        }
      });
    });
  },
};
